import { COLOR_PALETTE } from 'constants/ui';

export const categoryHeaderStyles = {
  padding: '4px 16px 1px',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  color: ({ palette }) => palette.text.placeholder,
};

const resultItemStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '3px 16px',
  cursor: 'pointer',
  transition: 'background-color 0.1s ease',

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
};

export const getResultItemSelectedStyles = ({ isSelected }) => ({
  ...resultItemStyles,
  ...(isSelected ? { backgroundColor: ({ palette }) => palette.background.disabled } : {}),
});

const resultItemIconBaseStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '20px',
  height: '20px',
  borderRadius: '6px',
  flexShrink: 0,
  transition: 'background-color 0.1s ease, color 0.1s ease',
};

export const getResultItemIconStyles = ({ isSelected }) => ({
  ...resultItemIconBaseStyles,
  backgroundColor: ({ palette }) =>
    isSelected ? COLOR_PALETTE.GRAY[7] : palette.background.disabled,
  color: ({ palette }) => (isSelected ? COLOR_PALETTE.GRAY[1] : palette.text.secondary),
});

export const resultItemContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
};

export const resultItemLabelStyles = {
  color: ({ palette }) => palette.text.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const resultItemBreadcrumbStyles = {
  color: ({ palette }) => palette.text.placeholder,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const resultItemDisabledStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '3px 16px',
  cursor: 'default',
  opacity: 0.5,
};

export const shortcutBadgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2px 6px',
  lineHeight: 1,
  borderRadius: '4px',
  backgroundColor: ({ palette }) => palette.background.disabled,
  color: ({ palette }) => palette.text.secondary,
  flexShrink: 0,
  whiteSpace: 'nowrap',
};

export const fieldValueStyles = {
  color: ({ palette }) => palette.text.placeholder,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '140px',
  flexShrink: 0,
};

export const copyButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '20px',
  height: '20px',
  borderRadius: '4px',
  flexShrink: 0,
  cursor: 'pointer',
  color: ({ palette }) => palette.text.placeholder,
  transition: 'background-color 0.1s ease, color 0.1s ease',

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
    color: ({ palette }) => palette.text.dark,
  },
};

export const copiedBadgeStyles = {
  color: ({ palette }) => palette.text.placeholder,
  flexShrink: 0,
  whiteSpace: 'nowrap',
};
